class CookieStorage {
  static set(name, value, days = 365, path = '/') {
    const expires = new Date();

    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=${path};`;
  }

  static get(name) {
    // Ищем cookie вручную, без регулярного выражения
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const eqIndex = cookie.indexOf('=');
      if (eqIndex === -1) continue;
      const key = cookie.substring(0, eqIndex);
      if (key === name) {
        return decodeURIComponent(cookie.substring(eqIndex + 1));
      }
    }
    return null;
  }

  static delete(name, path = '/') {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
  }

  static has(name) {
    return this.get(name) !== null;
  }
}

export { CookieStorage };
